export const LOADING_FORM_REVIEW = 'LOADING_FORM_REVIEW';
export const ERROR_FORM_REVIEW = 'ERROR_FORM_REVIEW';
export const RESET_FORM_REVIEW = 'RESET_FORM_REVIEW';
